var React = require('react');

function TrashBlack (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"trash-black","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"trash-black-2","transform":"translate(-456.000000, -900.000000)","fill":"#2b2f35"},React.createElement("path",{"d":"M457.111111,917.777778 C457.111111,919 458.111111,920 459.333333,920 L468.222222,920 C469.444444,920 470.444444,919 470.444444,917.777778 L470.444444,904.444444 L457.111111,904.444444 L457.111111,917.777778 L457.111111,917.777778 Z M471.555556,901.111111 L467.666667,901.111111 L466.555556,900 L461,900 L459.888889,901.111111 L456,901.111111 L456,903.333333 L471.555556,903.333333 L471.555556,901.111111 L471.555556,901.111111 Z","id":"Shape"})))]);
}

TrashBlack.defaultProps = {"width":"16px","height":"20px","viewBox":"0 0 16 20","version":"1.1"};

module.exports = TrashBlack;

TrashBlack.default = TrashBlack;
